import type { BuildingSocietyLoanConfig } from '../BuildingSocietyLoanConfig';

export const loan: BuildingSocietyLoanConfig = {
    overview: {
        highlights: {
            showInstallment: false,
            showBalance: false,
            showRepayments: false,
            showLoanAmount: false,
        },
        list: {
            showIbanAndBic: false,
            showLoanAmount: false,
            showNextInstallmentDate: false,
            showDebitInterestRate: false,
            showAdditionalInfo: false,
            showStartDate: false,
        },
    },
    settingsDetails: {
        showSlashedBBAN: false,
    },
};
